export class EnvironmentProduction {
  name = 'prod'
  prod = true
  angularProd = true
  dev = false
  test = false

  appUrl = 'https://www.naturalcycles.com/app' // todo: should change to app.naturalcycles.com
  websiteHost = 'https://www.naturalcycles.com'

  sentryDsn: string | undefined = 'https://fb8015dcff814dfdab732cd16a882d1f@sentry.io/206330'

  apiUrl = 'https://api-prod.naturalcycles.com/api/v3'

  mixpanelId: string | undefined = '1430318304171440bfd5c9b90be6ab60'

  gmapsKey = 'AIzaSyD3xET4oH_39HCkdHjq42fDStNr5UV30Gw'
  recaptchaEnabled = true
  recaptchaSiteKey = '6LfGQrkUAAAAANmFycJdKWgXfQs0aUob5TsbOtxE'
  cookiebotId: string | undefined = '7bbeaa48-b680-4fa7-95eb-18d1da470039'
  googlePayMerchantId: string | undefined = 'BCR2DN6T47BYFAYU'

  googleWebClientId = '496314433486-2vitum0n58a7aqmtfjrvp5le5up785mq.apps.googleusercontent.com'

  appleWebClientId = 'com.naturalcycles.websignin'
}

export class Environment extends EnvironmentProduction {}

export const env = new EnvironmentProduction()
